import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { BannerItem, useNavigation } from '@/view/home/supportScript';
import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'bannerCard',
  props: {
    itemData: {}
  },
  setup(__props: any) {

const { goToPath } = useNavigation()

const props = __props

const noticeCard1 = computed(() => {
  if (props.itemData.noticeData) {
    const lang = localStorage.getItem('lang') || 'en'
    const data = props.itemData.noticeData[lang] || props.itemData.noticeData['en'] || {}
    return data.notice1 || { url: '', redirectUrl: '', display: false }
  }
  return props.itemData.notice1 || { url: '', redirectUrl: '', display: false }
})
const noticeCard2 = computed(() => {
  if (props.itemData.noticeData) {
    const lang = localStorage.getItem('lang') || 'en'
    const data = props.itemData.noticeData[lang] || props.itemData.noticeData['en'] || {}
    return data.notice2 || { url: '', redirectUrl: '', display: false }
  }
  return props.itemData.notice2 || { url: '', redirectUrl: '', display: false }
})
const noticeCard3 = computed(() => {
  if (props.itemData.noticeData) {
    const lang = localStorage.getItem('lang') || 'en'
    const data = props.itemData.noticeData[lang] || props.itemData.noticeData['en'] || {}
    return data.notice3 || { url: '', redirectUrl: '', display: false }
  }
  return props.itemData.notice3 || { url: '', redirectUrl: '', display: false }
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createBlock(_component_van_row, { class: "home_banner" }, {
    default: _withCtx(() => [
      _createVNode(_component_van_col, { span: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              (noticeCard1.value.display)
                ? (_openBlock(), _createBlock(_component_van_col, {
                    key: 0,
                    span: "24",
                    style: {"padding-right":"10px"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: noticeCard1.value.url,
                        alt: "",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goToPath)(noticeCard1.value.redirectUrl)))
                      }, null, 8, _hoisted_1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (noticeCard2.value.display)
                ? (_openBlock(), _createBlock(_component_van_col, {
                    key: 1,
                    span: "24",
                    style: {"padding-right":"10px"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: noticeCard2.value.url,
                        alt: "",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goToPath)(noticeCard2.value.redirectUrl)))
                      }, null, 8, _hoisted_2)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (noticeCard3.value.display)
        ? (_openBlock(), _createBlock(_component_van_col, {
            key: 0,
            span: "12"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: noticeCard3.value.url,
                alt: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(goToPath)(noticeCard3.value.redirectUrl)))
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})